import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api';

export const register = createAsyncThunk('auth/register', async ({ email, password, displayName }, { rejectWithValue }) => {
  try {
    const { data } = await api.post('/auth/register', { email, password, displayName });
    return data;
  } catch (err) {
    return rejectWithValue(err.response?.data?.error || 'Registration error');
  }
});

export const login = createAsyncThunk('auth/login', async ({ email, password }, { rejectWithValue }) => {
  try {
    const { data } = await api.post('/auth/login', { email, password });
    localStorage.setItem('accessToken', data.accessToken);
    localStorage.setItem('refreshToken', data.refreshToken);
    return data;
  } catch (err) {
    return rejectWithValue(err.response?.data?.error || 'Invalid credentials');
  }
});

export const loadUser = createAsyncThunk('auth/loadUser', async (_, { rejectWithValue }) => {
  const token = localStorage.getItem('accessToken');
  if (!token) return rejectWithValue('No token');
  try {
    const { data } = await api.get('/auth/me');
    return data;
  } catch (err) {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    return rejectWithValue('Invalid token');
  }
});

export const resendVerification = createAsyncThunk('auth/resendVerification', async (email, { rejectWithValue }) => {
  try {
    const { data } = await api.post('/auth/resend-verification', { email });
    return data;
  } catch (err) {
    return rejectWithValue(err.response?.data?.error || 'Error resending verification');
  }
});

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: null,
    wallet: null,
    loading: false,
    error: null,
    registeredEmail: null,
    verificationMessage: null
  },
  reducers: {
    logout(state) {
      state.user = null;
      state.wallet = null;
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
    },
    clearError(state) {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(register.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(register.fulfilled, (state, action) => {
        state.loading = false;
        state.user = null;
        state.registeredEmail = action.payload.user.email;
        state.verificationMessage = action.payload.message;
      })
      .addCase(register.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(login.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.user;
        state.wallet = action.payload.wallet;
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(loadUser.pending, (state) => { state.loading = true; })
      .addCase(loadUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(loadUser.rejected, (state) => {
        state.loading = false;
        state.user = null;
      })
      .addCase(resendVerification.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(resendVerification.fulfilled, (state, action) => {
        state.loading = false;
        state.verificationMessage = action.payload.message;
      })
      .addCase(resendVerification.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { logout, clearError } = authSlice.actions;
export default authSlice.reducer;
